import React from 'react'

import '../css/CloudComputingPhotoLoader.css'

import MyPic from '../images/AWS-Practioner.jpeg'


const CloudComputingPhotoLoader = () => {
  return (
    <div className='cloud-computing-PhotoLoader'>
        <img src={MyPic} alt='MyPic' className='cloud-computing-photo' />
    </div>
  )
}

export default CloudComputingPhotoLoader